module.exports = __webpack_public_path__ + "img/waze_logo.43d7df70.png";